import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '@reveni-io/reveni-ui'

import { getClaimPayload } from './helpers'

const useOpenClaim = ({
  storeId,
  labelId,
  fetchData,
  setToastInfo,
  openClaimService,
  fetchTimeline,
  uploadImageService,
  resourceId,
}) => {
  const { t } = useTranslation()
  const [showOpenClaimModal, setShowOpenClaimModal] = useState(false)
  const { fetchData: openClaim, loading: openingClaim } = useFetch(openClaimService, {
    doInitialRequest: false,
  })

  const openOpenClaimModal = () => {
    setShowOpenClaimModal(true)
  }
  const closeOpenClaimModal = () => {
    setShowOpenClaimModal(false)
  }
  const onOpenClaim = async info => {
    try {
      await openClaim({
        storeId,
        labelId,
        resourceId,
        payload: getClaimPayload(info),
      })
      closeOpenClaimModal()
      fetchData()
      fetchTimeline()
      setToastInfo({
        show: true,
        message: t('Incidencia recibida correctamente. Te responderemos lo antes posible.'),
        type: 'success',
      })
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  const uploadClaimImage = async imageFile => {
    const formData = new FormData()
    formData.append('image', imageFile)
    const response = await uploadImageService({ storeId, resourceId, formData })
    return { id: response?.data?.id, url: response?.data.url }
  }

  return {
    showOpenClaimModal,
    openOpenClaimModal,
    closeOpenClaimModal,
    onOpenClaim,
    openingClaim,
    uploadClaimImage,
  }
}

export default useOpenClaim
